/* eslint-disable max-statements */
var scriptLoader = (function () {
    var alreadyLoaded = {};
    var load = function (scriptObj) {
        var url = scriptObj.url, defer = scriptObj.defer;
        if (alreadyLoaded[url]) {
            return alreadyLoaded[url];
        }
        alreadyLoaded[url] = new Promise(function (resolve, reject) {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = url;
            if (defer)
                script.defer = defer;
            script.addEventListener('load', function () {
                resolve(script);
            }, false);
            script.addEventListener('error', function () { return reject(script); }, false);
            document.body.appendChild(script);
        });
        return alreadyLoaded[url];
    };
    return function (scriptsObj) {
        if (Array.isArray(scriptsObj)) {
            return Promise.all(scriptsObj.map(load));
        }
        else {
            return load(scriptsObj);
        }
    };
})();
export default scriptLoader;
//# sourceMappingURL=loadScript.js.map